"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
require("./Toast.scss");
var REF_ARROW = 'arrow';
var REF_CONTAINER = 'container';
var REF_MESSAGE = 'message';
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toast.prototype.componentDidMount = function () {
        this.reposition();
    };
    Toast.prototype.componentDidUpdate = function () {
        this.reposition();
    };
    Toast.prototype.reposition = function () {
        var container = react_dom_1.default.findDOMNode(this.refs[REF_CONTAINER]);
        var message = react_dom_1.default.findDOMNode(this.refs[REF_MESSAGE]);
        var arrow = react_dom_1.default.findDOMNode(this.refs[REF_ARROW]);
        var containerBox = container.getBoundingClientRect();
        var screenWidth = document.body.clientWidth;
        var messageOffset = (this.props.width / 2) - (message.offsetWidth / 2);
        var arrowOffset = (message.offsetWidth / 2);
        var messageRightEdge = containerBox.left + messageOffset + message.offsetWidth;
        if (messageRightEdge > screenWidth) {
            messageOffset = messageOffset - (messageRightEdge - screenWidth);
            arrowOffset = arrowOffset + (messageRightEdge - screenWidth);
        }
        message.style.left = messageOffset + "px";
        arrow.style.left = arrowOffset + "px";
    };
    Toast.prototype.render = function () {
        var _a = this.props, message = _a.message, width = _a.width, height = _a.height, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.position, position = _c === void 0 ? 'top' : _c;
        var style = {
            width: width,
            height: height
        };
        return (react_1.default.createElement("div", { className: classnames_1.default('toast', { 'toast--empty': message.length === 0 }, { 'is-top-position': position === 'top' }, { 'is-bottom-position': position === 'bottom' }, className), style: style, ref: "container" },
            children,
            react_1.default.createElement("div", { className: "toast__message", ref: "message" },
                react_1.default.createElement("div", { className: classnames_1.default('toast__arrow', { 'is-bottom-position': position === 'bottom' }, { 'is-hidden': position !== 'bottom' }), ref: "arrow" }),
                message,
                react_1.default.createElement("div", { className: classnames_1.default('toast__arrow', { 'is-top-position': position === 'top' }, { 'is-hidden': position !== 'top' }), ref: "arrow" }))));
    };
    return Toast;
}(react_1.Component));
exports.Toast = Toast;
